import React, { useState, useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import loadable from '@loadable/component'
import $ from 'jquery';

import { useQuery } from '@apollo/client'

import { ApolloProvider } from '@apollo/client'
import { client } from '../../_includes/forstok'
import { authHeaders, downloadWithAuth, fallbackFileNames } from '../../utils/api-auth'

import SingleLayout from '../../_layouts/single-layout'
import PopupContainer from '../../components/popup/popup.container'
import LinkComponent from '../../components/link/link.component'
import DropdownComponent from '../../components/dropdown/dropdown.component'
import ButtonComponent from '../../components/button/button.component'
import InputComponent from '../../components/input/input.component'
import IconComponent from '../../components/icon/icon.component'
import RoomList from './partials/list'
import GridLayout from '../../_layouts/grid-layout'
import { ButtonGroup, LinkContainer, FilterContainer, SearchFilterContainer, FilterWrapper } from '../../assets/stylesheets/shares.styles.jsx'
import { LogoContainer, SearchSalesOrderWrapper } from './rooms.styles'
import { getStorage, setStorage } from '../../assets/javascripts/function'
import moment from '../../assets/javascripts/moment-range'

const FilterDateRangePartial = loadable(() => import('./partials/filter.time'))
const FilterPartial = loadable(() => import('./partials/filter'))

const RoomGridIndex = () => {
  let location = useLocation();
  // console.log(getStorage('filterDateRangeBySalesOrders'))
  let initDateRange;

  const [isOpenPopup, setOpenPopup] = useState(false)
  const [isOpenPopupContainer, setOpenPopupContainer] = useState(false)
  const [modePopup, setModePopup] = useState('')
  const [dataIdPopup, setDataIdPopup] = useState('')
  const [dataDetailPopup, setDataDetailPopup] = useState('')
  const [isForceUpdate, setForceUpdate] = useState(false)

  const resetByOption = useCallback((opt, callback, noScroll) => {
    console.log('hello there!')
    if (callback) callback()
  })
  const evOpenPopup = (e) => {
    console.log('executed?');
    const buttonEl = e.target.closest('a')
    if (!buttonEl) return
    const popup = buttonEl.getAttribute('data-popup')
    const dataId = buttonEl.getAttribute('data-id')
    const dataDetail = buttonEl.getAttribute('data-detail')

    const props = {
      mode: popup,
      id: dataId,
      detail: JSON.parse(dataDetail)
    }
    evTooglePopup(props)
  }

  const evTooglePopup = (props) => {
    console.log('here?')
    console.log(isOpenPopup)
    if (isOpenPopup) {
      setOpenPopup(false)
      setModePopup('')
      setDataIdPopup('')
      setDataDetailPopup('')
      setOpenPopupContainer(false)
      document.getElementsByTagName("BODY")[0].classList.remove("is-immuned")
    } else {
      setOpenPopup(true)
      setModePopup(props.mode)
      setDataIdPopup(props.id)
      setDataDetailPopup(props.detail)
      setOpenPopupContainer(true)
      document.getElementsByTagName("BODY")[0].classList.add("is-immuned")
    }
  }

  const evCloseDropdown = (e) => {
    const containerEl = e.target.closest('._refContainer'),
      isOpen = containerEl.classList.contains('is-shown')
    console.log(containerEl);
    console.log(e.target);
    if (isOpen) {
      const ContainerRef = document.getElementsByClassName('_refContainer is-shown')
      if (ContainerRef.length) {
        for (var i = 0; i < ContainerRef.length; i++) {
          ContainerRef[i].classList.remove('is-shown')
        }
      }
    }
    document.getElementsByTagName("BODY")[0].classList.remove("is-immuned")
  }

  return (
    <ApolloProvider client={client}>
      <GridLayout>
        <FilterContainer>
          <SearchFilterContainer>
            {/* <SearchSalesOrderWrapper>
              <ButtonGroup>
                <DropdownComponent internalWidth='142px' openPosition='left' dataQaId='so-filter-print-status'>
                  <div aria-label='control'>
                    <ButtonComponent style={{paddingTop: '5px'}}  mode='clearOrder' isIndicatorArrow={true} isIndicatorArrowColor='#494949'>Nama</ButtonComponent>
                  </div>
                  <div aria-label='body'>
                    <div className='_refFilterDropdown' >
                      <LinkContainer  align='left'>
                        <LinkComponent mode='clear' as='a' to='#' data-search-by='channel_order_id'>Nama</LinkComponent>
                        <LinkComponent mode='clear' as='a' to='#' data-search-by='forstok_order_id'>Kelas</LinkComponent>
                      </LinkContainer>
                    </div>
                  </div>
                </DropdownComponent>
              </ButtonGroup>
              <InputComponent mod='order' name='search-input' placeholder='Cari' iconLeft={true} style={{padding: '0 10px'}}/>
              <IconComponent name='search' width='16px'></IconComponent>
            </SearchSalesOrderWrapper> */}
            <FilterWrapper>
              <LinkComponent style={{ lineHeight: '2em' }} to='#' mode='clearlink' onClick={() => {
                let groupFilter = getStorage('filterBySalesOrders');
                console.log('test');

                downloadWithAuth('https://genios-api.genios.id/room', fallbackFileNames.rooms());
              }
              }>Download</LinkComponent>
            </FilterWrapper>
            <FilterWrapper>
              <LinkComponent style={{ lineHeight: '2em' }} to='#' mode='clearlink' onClick={() => {
                var elem = document.getElementById('theFile');
                if (elem && document.createEvent) {
                  var evt = document.createEvent("MouseEvents");
                  evt.initEvent("click", true, false);
                  elem.dispatchEvent(evt);
                }
              }
              }>Upload</LinkComponent>
            </FilterWrapper>
            <input type="file" id="theFile" style={{ display: 'none' }} onChange={() => {
              var that = this;
              var elem = document.getElementById('theFile');
              console.log(elem);

              var file = elem.files[0];

              var formData = new FormData();

              // add assoc key values, this will be posts values
              formData.append("file", file);


              console.log(file);
              $.ajax({
                type: "POST",
                url: "https://genios-api.genios.id/upload_room",
                headers: authHeaders(),
                // xhr: function () {
                //     // var myXhr = $.ajaxSettings.xhr();
                //     // if (myXhr.upload) {
                //     //     myXhr.upload.addEventListener('progress', that.progressHandling, false);
                //     // }
                //     // return myXhr;
                // },
                success: function (data) {
                  // your callback here
                  window.location.reload(false)
                },
                error: function (error) {
                  // handle error
                  alert(error.statusText);
                  console.log(error);
                },
                // async: true,
                data: formData,
                // cache: false,
                contentType: false,
                processData: false,
                timeout: 120000
              });
              //   https://stackoverflow.com/questions/2320069/jquery-ajax-file-upload
            }} />
          </SearchFilterContainer>
        </FilterContainer>
        <RoomList evOpenPopup={evOpenPopup} />
        <PopupContainer isOpen={isOpenPopup} isOpenContainer={isOpenPopupContainer} mode={modePopup} dataId={dataIdPopup} evTooglePopup={evTooglePopup} dataDetail={dataDetailPopup} />
      </GridLayout>
    </ApolloProvider>
  )
}

export default RoomGridIndex;
